import { render, staticRenderFns } from "./userInfo_code.vue?vue&type=template&id=1e2a31f0&scoped=true&"
import script from "./userInfo_code.vue?vue&type=script&lang=js&"
export * from "./userInfo_code.vue?vue&type=script&lang=js&"
import style0 from "./userInfo_code.vue?vue&type=style&index=0&id=1e2a31f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2a31f0",
  null
  
)

export default component.exports